var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ContestOfferSummaryBidderDetails',{attrs:{"title":_vm.title,"bidder-data":_vm.bidderData}})}
var staticRenderFns = []

export { render, staticRenderFns }